<template>
  <aside
    v-cloak
    class="bg-white w-full lg:max-w-2xl sticky top-24"
  >
    <div
      v-vetster-scroll="{
        wheelPropagation: false,
        maxScrollbarLength: 120,
        updateOnResizeDeep: true,
      }"
      class="search-scroll-container sm:border-r border-neutral-200 mr-4"
    >
      <div class="divide-y divide-neutral-200">
        <vetster-search-facet-group
          :label="$t('search.your-location')"
          group="LOCATION"
          classes="pb-5 space-y-6 pr-0 sm:px-4"
          :expandable="false"
        >
          <vetster-search-location-picker
            :locale="locale"
            :countries="country"
            :location="displayCity"
          />
        </vetster-search-facet-group>

        <vetster-search-day-input :expanded="!hasName" />

        <vetster-search-facet-group
          :label="$t('search.time-range')"
          group="TIME"
          :expanded="!hasName"
        >
          <vetster-search-time-picker />
        </vetster-search-facet-group>
        <vetster-search-designation-input
          v-if="isWellness"
          :expanded="!hasName"
        />
        <vetster-species-treated-input :expanded="hasSpeciesTreated" />
        <vetster-areas-of-interest-input :expanded="hasAreaOfInterest" />
        <vetster-search-language-input :expanded="hasLanguage" />
        <vetster-search-name-input :expanded="hasName" />
      </div>
    </div>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex';

import VetsterAreasOfInterestInput from '@/components/VetsterAreasOfInterestInput';
import VetsterSearchDayInput from '@/components/VetsterSearchDayInput';
import VetsterSearchDesignationInput from '@/components/VetsterSearchDesignationInput';
import VetsterSearchFacetGroup from '@/components/VetsterSearchFacetGroup';
import VetsterSearchLanguageInput from '@/components/VetsterSearchLanguageInput';
import VetsterSearchLocationPicker from '@/components/VetsterSearchLocationPicker';
import VetsterSearchNameInput from '@/components/VetsterSearchNameInput';
import VetsterSearchTimePicker from '@/components/VetsterSearchTimePicker';
import VetsterSpeciesTreatedInput from '@/components/VetsterSpeciesTreatedInput';

export default {
  name: 'VetsterSearchPanel',

  components: {
    VetsterAreasOfInterestInput,
    VetsterSearchDayInput,
    VetsterSearchDesignationInput,
    VetsterSearchFacetGroup,
    VetsterSearchNameInput,
    VetsterSearchLanguageInput,
    VetsterSearchLocationPicker,
    VetsterSearchTimePicker,
    VetsterSpeciesTreatedInput,
  },

  props: {
    country: {
      type: [String],
      required: true,
    },
    filters: {
      type: [Object, Array],
      default: () => ({}),
    },
    locale: {
      type: String,
      default: null,
    },
    isGlobalUser: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters('search', [
      'displayCity',
      'getAreasOfInterest',
      'getLanguages',
      'hasAreaOfInterest',
      'hasLanguage',
      'hasName',
      'hasSpeciesTreated',
      'isWellness',
    ]),
  },

  async created() {
    await this.$store.commit('setIsGlobalUser', this.isGlobalUser);
  },
};
</script>

<style>
.search-scroll-container {
  height: calc(100vh - 6.25rem);
}
.search-scroll-container.ps > .ps__rail-y {
  background-color: transparent;
}

.search-scroll-container.ps .ps__rail-y:hover,
.search-scroll-container.ps .ps__rail-y:focus,
.search-scroll-container.ps .ps__rail-y.ps--clicking {
  opacity: 0.6;
}
.search-scroll-container.ps > .ps__rail-y > .ps__thumb-y {
  background-color: transparent;
  background-color: #aaa;
}
</style>
